import { SystemStyleObject } from "@mui/system";
import { Theme, useTheme, Box } from "@mui/material";
import { CostScore } from "@labs/shared/types/Solution.ts";

type CostScoreDisplayProps = {
  costScore: CostScore;
  sx?: SystemStyleObject<Theme>;
};

export const CostScoreDisplay = ({
  costScore,
  sx = {},
}: CostScoreDisplayProps) => {
  const theme = useTheme();
  const roundedScore = Math.round(costScore);
  const maxScore = 5;

  if (!costScore) return <span>N/A</span>;

  const getActiveColor = (score: number) => {
    if (score <= 2) return theme.palette.costScore.active.low;
    if (score === 3) return theme.palette.costScore.active.medium;
    return theme.palette.costScore.active.high;
  };

  return (
    <Box component="span" sx={{ display: "inline-flex", ...sx }}>
      {[...Array(maxScore)].map((_, index) => (
        <span
          key={index}
          style={{
            color:
              index < roundedScore
                ? getActiveColor(roundedScore)
                : theme.palette.costScore.inactive,
          }}
        >
          $
        </span>
      ))}
    </Box>
  );
};
